export default __webpack_public_path__ + "static/media/poster.689bbd4c.jpeg";